import React from "react";
import {Bar, BarChart, CartesianGrid, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

export default function RevenueRange({ data }) {
    const rows = data ?? [];

    // Generate letter labels (A:, B:, C:, etc.)
    const getLetterLabel = (index) => {
        return String.fromCharCode(65 + index) + ":";
    };

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    return (
        <div className="hc-box">
            <div className="hc-title">Revenue</div>
            <div className="hc-body">
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                        layout="vertical"
                        data={rows}
                        margin={{ top: 0, right: 10, left: 10, bottom: 0 }}
                        barSize={30}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" />
                        <YAxis
                            type="category"
                            dataKey="revenueRange"
                            axisLine={false}
                            tickLine={false} 
                            tick={{
                                textAnchor: "start",
                                dx: -55,
                                fontSize: 10
                            }}
                            tickFormatter={(value) =>
                                value
                                    .split("_")
                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                    .join(" ")
                            }
                        />
                        <Bar dataKey="count" stackId="a" fill="#ee5a38" name="Count" radius={[5, 5, 5, 5]} stroke="#b83f28" strokeWidth={2}>
                            <LabelList
                                dataKey="count"
                                content={(props) => {
                                    const { x, y, width, height, value } = props;
                                    const barLength = width;
                                    const threshold = 60; // pixels

                                    // If bar is too short, position outside; otherwise inside
                                    const labelX = barLength < threshold ? x + width + 5 : x + 5;
                                    const labelFill = barLength < threshold ? "#333" : "white";

                                    return (
                                        <text
                                            x={labelX}
                                            y={y + height / 2}
                                            fill={labelFill}
                                            fontSize={12}
                                            dominantBaseline="middle"
                                        >
                                            {value?.toLocaleString()}
                                        </text>
                                    );
                                }}
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
